import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Menu } from "lucide-react";

import { Sidebar } from "./admin/Sidebar";
import { DashboardOverview } from "./admin/DashboardOverview";
import { TicketScanner } from "./admin/TicketScanner";
import { SalesManagement } from "./admin/SalesManagement";
import { BuyersList } from "./admin/BuyersList";
import { UsersManagement } from "./admin/UsersManagement";
import { PlansManagement } from "./admin/PlansManagement";
import { FinancialSummary } from "./admin/FinancialSummary";
import { FinanceCenter } from "./admin/FinanceCenter";
import { SettingsPage } from "./admin/SettingsPage";
import { EmailsPage } from "./admin/EmailsPage";
import Backstage from "./admin/Backstage";
import AdminsManagement from "./admin/AdminsManagement";
import { useAuth } from "../context/AuthContext";
import { canAccess } from "../lib/permissions";

// Route guard: only renders children when the current admin role is allowed
// for the given page id. Otherwise redirects to /admin (Dashboard, which
// everyone can see).
const RoleRoute = ({ pageId, children }) => {
  const { user } = useAuth();
  if (!user) return null;
  if (!canAccess(user.role, pageId)) return <Navigate to="/admin" replace />;
  return children;
};

const AdminDashboard = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#09090b]" data-testid="admin-dashboard">
      {/* Mobile header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-30 bg-zinc-900/95 backdrop-blur border-b border-white/10 px-4 py-3 flex items-center gap-3">
        <button
          onClick={() => setMobileOpen(true)}
          className="text-zinc-300 hover:text-white p-1"
          data-testid="mobile-menu-btn"
        >
          <Menu className="w-6 h-6" />
        </button>
        <h1 className="text-white font-semibold text-sm">Bilhetez</h1>
      </div>
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <main className="lg:ml-64 p-4 pt-16 lg:p-8 lg:pt-8">
        <Routes>
          <Route index element={<DashboardOverview />} />
          <Route path="scanner"   element={<RoleRoute pageId="checkins"><TicketScanner /></RoleRoute>} />
          <Route path="sales"     element={<RoleRoute pageId="tickets"><SalesManagement /></RoleRoute>} />
          <Route path="buyers"    element={<RoleRoute pageId="buyers"><BuyersList /></RoleRoute>} />
          <Route path="users"     element={<RoleRoute pageId="users"><UsersManagement /></RoleRoute>} />
          <Route path="plans"     element={<RoleRoute pageId="plans"><PlansManagement /></RoleRoute>} />
          <Route path="financial" element={<RoleRoute pageId="finance"><FinanceCenter /></RoleRoute>} />
          <Route path="settings"  element={<RoleRoute pageId="settings"><SettingsPage /></RoleRoute>} />
          <Route path="emails"    element={<RoleRoute pageId="communication"><EmailsPage /></RoleRoute>} />
          <Route path="admins"    element={<RoleRoute pageId="admins"><AdminsManagement /></RoleRoute>} />
          <Route path="backstage" element={<Backstage />} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminDashboard;
